import { Helmet } from "react-helmet";
import AnimalGrid from "components/animalgrid";
import BodyText from "components/bodytext";
import ContentBox from "components/contentbox";
import HeaderText from "components/headertext";
import PageGallery from "components/pagegallery";
import collectionMeta from "content/collections/boa-constrictors.json";
import { animalGridFromJson } from "hooks/useGallery";

const animalGridData = animalGridFromJson(collectionMeta);

const BoaConstrictor = () => {
  return (
    <ContentBox>
      <Helmet>
        <title>{collectionMeta.commonName}</title>
        <meta
          name="description"
          content="See the Boa Constrictors (Boa imperator)
            that are being kept here and learn more about their captive husbandry."
        />
        <link rel="canonical" href="https://www.gcreptiles.com/boa-constrictors" />
      </Helmet>

      <HeaderText
        title={collectionMeta.commonName}
        subtitle={collectionMeta.scientificName}
      />

      <AnimalGrid data={animalGridData} />

      <BodyText>
        I've always wanted boa constrictors but to be honest I wasn't aware of
        the difference between <i>boa imperator</i> and <i>boa constrictor</i>{" "}
        until the late 90's (and back then the taxonomy was different). So the
        books and magazine articles I had before then talked about "boa
        constrictors" that could potentially reach 15 feet long and that is just
        too big for me.
      </BodyText>

      <BodyText>
        But then this thing called the Internet came around and taught me that
        these boas are two different species and so I've been watching them more
        closely since then. I have <i>boa imperators</i> currently but I stare
        at the <i>boa constrictors</i> - particularly the ones from Peru - on a
        regular basis.
      </BodyText>

      <BodyText>
        I started with a pair of Sharp albinos - Crush and Blizzard - but I also
        love the VPI T+ Albino gene so I have a pair of boas sporting those
        traits as well. I want to say that's enough boas but man, have you seen
        an VPI T+ with IMG and Aztec in it? Sooooooo hot.
      </BodyText>

      <PageGallery slug="boa-constrictors" maxWidth="900" />
    </ContentBox>
  );
};

export default BoaConstrictor;
